"use client";

import { cn } from "utils/functions";
import { sectionPaddingBottomClass, sectionPaddingTopClass } from "utils/sectionSpacingConstants";
import { AssetFragment } from "contentful/gql/graphql";
import ConversionPanelV3 from "components/ConversionPanel/ConversionPanelV3";
import LowCodeCommercialSaaSHeading from "./LowCodeCommercialSaaSHeading";
import LowCodeCommercialSaaSPointsCard from "./LowCodeCommercialSaaSPointsCard";
import LowCodeCommercialSaaSTable from "./LowCodeCommercialSaaSTable";

type LowCodeCommercialSaaSType = {
  componentType: string;
  content: any;
};

export default function LowCodeCommercialSaaS({
  id,
  json,
  assets,
}: {
  id: string;
  json: {
    componentTheme: string;
    paddingTop: string;
    paddingBottom: string;
    content: LowCodeCommercialSaaSType[] | undefined;
  };
  assets: (AssetFragment | undefined)[] | undefined;
}) {
  return (
    <section
      id={id}
      className={cn(
        json.componentTheme?.toLowerCase() == "dark"
          ? "dark bg-primary-dark-900 text-primary-neutral-100"
          : "bg-primary-neutral-50 text-primary-dark-800",
      )}
    >
      <div
        className={cn(
          "container mx-auto",
          sectionPaddingTopClass[(json?.paddingTop as keyof typeof sectionPaddingTopClass) ?? "Medium"],
          sectionPaddingBottomClass[(json?.paddingBottom as keyof typeof sectionPaddingTopClass) ?? "Medium"],
          "flex flex-col gap-sm",
        )}
      >
        {json.content?.map((item, index) => {
          switch (item.componentType) {
            case "heading":
              return <LowCodeCommercialSaaSHeading json={item.content} />;
            case "points-cards":
              return <LowCodeCommercialSaaSPointsCard json={item.content} />;
            case "cta-card":
              const data: any = {};
              if (item.content?.[0]?.elementLink) {
                data["callToActionCollection"] = {
                  items: [item.content?.[0]?.elementLink],
                };
              }
              return (
                <div className="pb-lg">
                  <ConversionPanelV3
                    key={`LowCodeDevs${item.componentType}-${index}`}
                    variation={"dark"}
                    heading={item.content?.[0]?.elementTitle || ""}
                    headingType={"H3"}
                    {...data}
                    // accentImage={accentImage}
                  />
                </div>
              );
            case "saas-table-card":
              return <LowCodeCommercialSaaSTable json={item.content} />;
            default:
              return null;
          }
        })}
      </div>
    </section>
  );
}
